
<template>
  <div class="card">
        <h5>{{editingCustomer ? 'Edit Customer' : customerAlreadyExists ? 'Customer Exists' : 'New Customer'}}</h5>
        <p v-if="isGlobalCustomer" class="validation-error">You are not able to edit global customers at this time</p>
        <hr>
        
        <div class="container p-0 m-0">
          <div class="row mb-2">
            <div class="col-4">
              <BasicTextInput 
                :disabled="isGlobalCustomer || customerAlreadyExists" 
                placeholder="TBGA" 
                label="Customer #" 
                v-model="customer.JdeNum"
                :validator="$v.customer.JdeNum"
                :validatorMsgMap="MsgMap"/>
            </div>
            <div class="col-8">
              <BasicTextInput 
                placeholder="DentaSmile" 
                label="Business Name" 
                :disabled="isGlobalCustomer || customerAlreadyExists"
                v-model="customer.Name"
                :validator="$v.customer.Name"
                :validatorMsgMap="MsgMap"/>
            </div>
          </div>
          <div class="row mb-2">
            <div v-if="dealerHasCustomerType" class="col">
              <BasicTextInput  :disabled="true" placeholder="" label="Customer Type" v-model="customer.CustomerType"/>
            </div>
            
          </div>
          <div v-if="!customerAlreadyExists" class="row mb-2">
            <div class="col">
              <BasicTextInput 
                placeholder="John" 
                label="First Name" 
                :disabled="isGlobalCustomer"
                v-model="customer.CustomerContact.FirstName"
                :validator="$v.customer.CustomerContact.FirstName"
                :validatorMsgMap="MsgMap"/>
            </div>
            <div class="col">
              <BasicTextInput 
                placeholder="Smith" 
                label="Last Name" 
                :disabled="isGlobalCustomer"
                v-model="customer.CustomerContact.LastName"
                :validator="$v.customer.CustomerContact.LastName"
                :validatorMsgMap="MsgMap"/>
            </div>
          </div>
          <div v-if="!customerAlreadyExists" class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="Address Line 1" label="Address Line 1" v-model="customer.Address.Line1"/>
            </div>
          </div>
          <div v-if="!customerAlreadyExists" class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="Suite" label="Suite" v-model="customer.Address.Line2"/>
            </div>
          </div>
          <div v-if="!customerAlreadyExists" class="row mb-2">
            <div class="col">
              <BasicTextInput :disabled="isGlobalCustomer" placeholder="City" label="City" v-model="customer.Address.City"/>
            </div>
            <div class="col">
              <StateSelect :disabled="isGlobalCustomer" placeholder="" label="State/Province" :key="statesUpdateKey" v-model="customer.Address.StateId" :states="states"/>
            </div>
            <div class="col">
              <ZipCodeInput :disabled="isGlobalCustomer" placeholder="Zip/Postal Code" label="Zip/Postal Code" v-model="customer.Address.ZipCode"/>
            </div>
          </div>

          <div v-if="!customerAlreadyExists" class="row mb-2">
            <div class="col-8">
              <CountrySelect :disabled="isGlobalCustomer" placeholder="" label="Country" v-model="customer.Address.CountryId"  @change="getStatesForCountry"/>
            </div>
            <div class="col-4">
              <PhoneNumberInput :disabled="isGlobalCustomer" placeholder="(513)600-7085" label="Phone #" v-model="customer.CustomerContact.PhoneNumber"/>
            </div>
          </div>
          <div v-if="customerAlreadyExists" class="row mb-2">
            <div class="col">
              The Customer Id for the Customer you are attempting to create is already in use in the system. The better course of action is to request access to this Shared Global Customer rather than create it as a Private Customer.
            </div>
          </div>
        </div>
       <div class="btn-wrapper">
          <button type="button" v-bind:class="accessRequested ? 'btn access-requested' : 'btn btn-secondary'" @click="cancelClicked">Cancel</button>
          <button type="button" v-if="customerAlreadyExists" class="btn btn-secondary" @click="requestAccess">Request Access</button>
          <button type="button" :disabled="isGlobalCustomer" class="btn btn-primary" @click="savePrivateCustomer">{{editingCustomer ? 'Save' : 'Add Customer'}}</button>
         </div>
      </div>
</template>

<script>
import { CustomerService } from '@/services';
import CountryService from '../services/countries'
import CountrySelect                    from '../components/inputComponents/CountrySelect';
import { validatorMsgMapBase, deepCopyObject,dealerEnum, getKeyByValue  } from "../modules/helpers";
import {
    required,
    requiredIf
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

export default {
  name: 'PrivateCustomerForm',
  components: {
    CountrySelect,
  },
  props:{
    value:{
      type: Object,
      default: () => {
        //fill in customerdetails
      }
    },
    editingCustomer: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{
      customerAlreadyExists: false,
      validatorMsgMapBase: validatorMsgMapBase,
      states: null,
      statesUpdateKey: 0,
      emptyCustomer: {Id: 0,
        JdeNum: '',
        Name: '',
        LicenseNumber: null,
        Specialty: null,
        PhoneNum: '',
        FaxNum: '',
        Addresses: [],
        CustomerContact: {
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          Email: null,
        },
        Address: {
          AddressId: 0,
          Name: '',
          Line1: '',
          Line2: '',
          City: '',
          StateId: null,
          CountryId: null,
          ZipCode: '',
          LocationCode: '',
        },
        IsPrivate: true
      },
      customer: this.value,
      accessRequested: false,
      // responseCustomer: {}
    }
  },
  validations() {
    return {
      customer: {
        JdeNum: {
          jdeRequired: required
        },
        Name: {
          required :  requiredIf(function(customer){
        	              return !(customer.CustomerContact.FirstName || customer.CustomerContact.LastName); 
                      }),
        },
        CustomerContact: {
          FirstName: {
            required : requiredIf(function(){
        	              return !(this.customer.Name); 
                      }),
          },
          LastName: {
            required : requiredIf(function(){
        	              return !(this.customer.Name); 
                      }),
          }
        }
        
      }
    }
  },
  methods: {
    getStatesForCountry(e){
      CountryService.states(Number(e.target.value))

        .then(res => {
          this.statesUpdateKey++;
          this.states = res;
          if(!e.target.mimic) this.customer.Address.StateId = null;
        });
    },
    cancelClicked(){
      if(this.customerAlreadyExists){
        this.customerAlreadyExists = false;
      } else {
        this.$emit('cancelPrivateCustomer');
      }
    },
    savePrivateCustomer(){
      this.customer.Addresses = [{...this.customer.Address}]
      
      if (this.$v.customer.$invalid){
        this.$v.customer.$touch();
        this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
        return;
      }
      if(this.editingCustomer){
        this.updateCustomer()
      } else {
        this.createNewCustomer()
      }
      // this.customer = deepCopyObject(this.emptyCustomer);
      // this.$emit('privateCustomerSaved', this.customer)
    },
    createNewCustomer(){
      this.customer.PrivateCustomerBypass = this.customerAlreadyExists ? true : false;
      CustomerService.create(this.customer)
        .then(res => {
          if(res.DisplayConfirmationModal){
            this.customerAlreadyExists = true;
          } else {

            this.customerAlreadyExists = false;
            this.$emit('privateCustomerSaved', res)
            this.$store.dispatch('ADD_NOTIFICATION', { text: 'New private customer created', type: 'success' });
            this.customer = deepCopyObject(this.emptyCustomer);
            
          }
        })
        .catch(err => {
          console.log(err)
          // this.customerAlreadyExists = true;
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
        })
    },
    requestAccess(){
      CustomerService.requestAccess(this.customer.JdeNum)
        .then(res => {
          this.$emit('accessRequested')
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Access has been requested! ', type: 'success' });
          this.accessRequested = true;
        })
        .catch(err => {
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Unable to request access at this time ', type: 'success' });
          console.log(err)
        })
    },
    updateCustomer(){
      CustomerService.update(this.customer)
        .then(res => {
          this.customerAlreadyExists = false;
          this.$emit('privateCustomerSaved', res)
          this.$store.dispatch('ADD_NOTIFICATION', { text: 'Customer updated', type: 'success' });
          this.customer = deepCopyObject(this.emptyCustomer);
        })
        .catch(err => {
          console.log(err)
          this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error' });
        })
    },
    setCustomer(){
      if(this.customer.CustomerContact === null){
        this.customer.CustomerContact = this.emptyCustomer.CustomerContact;
      }
      if(this.customer.Address === null){
        this.customer.Address = this.emptyCustomer.CustomerContact;
      }
    }
  },
  computed: {
    ...mapState(['currentUser']),
    dealerHasCustomerType(){
      let dealer = getKeyByValue(dealerEnum, this.currentUser.DealerId)
      return dealer === 'Atlantis Dental'
    },
    MsgMap(){
      return {
        ...this.validatorMsgMapBase,
        required:  'Name is Required',
        jdeRequired:  'Customer # is Required',
      };
    },
    isGlobalCustomer(){
      return !this.customer.IsPrivate
    }
  },
  created(){
    this.setCustomer();
    const data = {
      target: {
        mimic: true,
        value: this.customer.Address.CountryId || 1
      }
    }
    this.getStatesForCountry(data);
  }
}
</script>

<style lang="scss" scoped>
  .card{ 
    max-width: 500px;
    width: 500px;
    padding: 25px;
    .modal-card {
      background-color: white;
    }
  }
  .btn-wrapper{
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .btn {
      margin: 5px;
    }
  }

  .access-requested {
    color: white;
    background-color: forestgreen;
  }
</style>